"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WATCH_ACTION = exports.WATCH_API_ENDPOINT = exports.ITEM_VARIATION_API_PATH = exports.WATCH_LISTS_API_PATH = exports.WATCH_API_PATH = exports.TARGET_APP_NAME = exports.PAGE_NAME = exports.SESSION_STORAGE = void 0;
exports.SESSION_STORAGE = {
    EXPIRY_TIME_OFFSET: 30,
    SESSION_KEY_NAME: 'favorites_ui_watch_Item_Data',
};
exports.PAGE_NAME = {
    ADD_TO_WATCH: 'addToWatch',
    REMOVE_FROM_WATCH: 'removeFromWatch',
};
exports.TARGET_APP_NAME = 'myebaynode';
exports.WATCH_API_PATH = '/mye/myebay/watch/';
exports.WATCH_LISTS_API_PATH = '/mye/myebay/watch/lists';
exports.ITEM_VARIATION_API_PATH = '/mye/myebay/item/variation';
exports.WATCH_API_ENDPOINT = {
    ADD: 'add',
    REMOVE: 'remove',
};
exports.WATCH_ACTION = {
    ADD_ACTION: 'add',
    REMOVE_ACTION: 'remove',
};
